<template>
  <el-card style="margin-bottom: 50px">
    <div class="details-distribution-container">
      <hm-step
        :scroll="true"
        :steps="steps"
        @scroll="windowScroll"
        :step="currentStep"
      ></hm-step>
      <el-scrollbar :style="{ height: scrollHeight + 'px' }">
        <div>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="product-ruleForm"
          >
            <div id="base">1.基本信息</div>
            <el-form-item label="商品货号：" prop="goodsSn">
              <el-input
                size="small"
                class="mr10 ipt"
                :show-message="showGoodsSn"
                v-model.trim="ruleForm.goodsSn"
                placeholder="请选择商品货号"
                readonly
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="商品名称：" prop="wxshopSpuName">
              <el-input
                disabled
                size="small"
                clearable
                class="mr10 ipt"
                v-model.trim="ruleForm.wxshopSpuName"
                placeholder="例如：农夫山泉矿泉水550ml"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="商品分类："
              class="is-required"
              prop="category"
            >
              <el-cascader
                disabled
                v-model="ruleForm.wxshopCategoryId"
                :show-message="isShowCategoryErr"
                :show-all-levels="false"
                size="small"
                :props="categoryFunc"
                ref="cascader"
                clearable
              ></el-cascader>
              <el-button
                disabled
                class="btn"
                size="small"
                @click="toUrl('MicroShopGoodsCate')"
                icon="hmicon icon-hao"
                >新建分类</el-button
              >
              <div class="form-item-tip">
                此分类为微店商品分类，商品分类用于手机端显示商品分类
              </div>
            </el-form-item>
            <el-form-item label="商品类型：" class="is-required">
              <el-radio-group v-model="ruleForm.spuType">
                <el-radio disabled label="reality">
                  实物商品
                  <span class="form-item-tip">需要发货</span>
                </el-radio>
                <el-radio disabled label="virtual">
                  虚拟商品
                  <span class="form-item-tip">无需发货</span>
                </el-radio>
              </el-radio-group>
              <div class="form-item-tip">商品类型一旦选择，不可更改</div>
              <div v-if="ruleForm.spuType === 'virtual'">
                <div class="flex item-center">
                  <span class="mr10">虚拟商品售后</span>
                  <el-radio-group v-model="ruleForm.memberLaunchRefund">
                    <el-radio label="no" disabled>不支持买家申请退款</el-radio>
                    <el-radio label="yes" disabled>支持买家申请退款</el-radio>
                  </el-radio-group>
                </div>
                <div class="form-item-tip">
                  商品详情页将展示“不支持申请退款的说明”，买家只能主动联系商家处理
                </div>
              </div>
            </el-form-item>
            <el-form-item
              label="商品预购："
              class="is-required"
              prop="overstockSalesMode"
            >
              <el-switch
                disabled
                v-model="ruleForm.overstockSales"
                active-text="开启"
                inactive-text="关闭"
                active-color="#13ce66"
                active-value="open"
                inactive-value="close"
              ></el-switch>
              <div class="form-item-tip">
                预购关闭，则库存按照实际库存出；预购开启则商品按照预购库存出
              </div>
              <div
                class="flex item-center"
                v-if="ruleForm.overstockSales === 'open'"
              >
                <span class="mr10">预购开启</span>
                <el-radio-group v-model="ruleForm.overstockSalesMode">
                  <el-radio label="date" disabled>
                    <el-date-picker
                      disabled
                      v-model="ruleForm.deliveryDeadline"
                      type="datetime"
                      align="right"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="请选择开售时间"
                      size="small"
                      class="mr10"
                    ></el-date-picker
                    >前发货
                  </el-radio>
                  <el-radio label="day" disabled>
                    付款成功
                    <el-input
                      disabled
                      size="small"
                      clearable
                      style="width: 80px"
                      class="mr10 ipt"
                      @input="filterGt0('afterPayDays')"
                      maxlength="2"
                      v-model.trim="ruleForm.afterPayDays"
                    ></el-input
                    >天后发货
                  </el-radio>
                </el-radio-group>
              </div>
              <div
                class="form-item-tip primary"
                v-if="ruleForm.overstockSales === 'open'"
              >
                注意：只允许设置1-90天内发货，请务必按照约定时间发货，以免引起客户投诉
              </div>
            </el-form-item>
            <el-form-item label="商品卖点：">
              <el-input
                disabled
                size="small"
                v-model="ruleForm.sellingPoint"
                type="textarea"
                maxlength="50"
                placeholder="请输入商品卖点"
              ></el-input>
              <div class="form-item-tip">
                在商品详情标题下显示卖点信息，也是分享给好友时显示的卖点信息，建议50字以内
              </div>
            </el-form-item>
            <el-form-item label="主图：">
              <my-upload
                disabled
                field="file"
                @crop-success="cropSuccess"
                @crop-upload-success="cropUploadSuccess"
                @crop-upload-fail="cropUploadFail"
                v-model="show"
                noCircle
                noSquare
                :width="750"
                :height="750"
                :headers="{ 'X-Access-Token': $token }"
                :params="{ fileDir: 'goodsCenter' }"
                :url="$uploadUrl"
                img-format="png"
              ></my-upload>
              <el-button
                disabled
                type="primary"
                size="small"
                v-show="!ruleForm.spuMainPic"
                @click="toggleShow"
                >上传</el-button
              >
              <span class="form-tip"
                >（主图仅可设置一张，图片尺寸建议750x750）</span
              >
              <div class="priview" v-if="ruleForm.spuMainPic">
                <img :src="ruleForm.spuMainPic" alt="主图" />
                <div class="opreat-wrapper flex item-center flex-center">
                  <el-button disabled type="text" @click="handleRemove"
                    >删除</el-button
                  >
                </div>
              </div>
            </el-form-item>
            <el-form-item label="轮播组图：" prop="listDetail">
              <my-upload
                disabled
                field="file"
                @crop-success="cropSuccess"
                @crop-upload-success="cropUploadSuccess"
                @crop-upload-fail="cropUploadFail"
                v-model="showDetail"
                noCircle
                noSquare
                :width="750"
                :height="750"
                :headers="{ 'X-Access-Token': $token }"
                :params="{ fileDir: 'goodsCenter' }"
                :url="$uploadUrl"
                img-format="png"
              ></my-upload>
              <el-button
                disabled
                type="primary"
                size="small"
                v-show="ruleForm.spuSlideShowPicList.length < 6"
                @click="toggleShowDetail"
                >上传</el-button
              >
              <span class="form-tip"
                >（列表详情图可设置6张，图片尺寸建议750x750）</span
              >
              <ul class="flex flex-wrap">
                <li
                  class="priview mr10"
                  v-show="v"
                  v-for="(v, i) in ruleForm.spuSlideShowPicList"
                  :key="i"
                >
                  <img :src="v" alt="列表详情图" />
                  <div class="opreat-wrapper flex item-center flex-center">
                    <el-button type="text" disabled @click="setFirst(i)"
                      >设为第一张图</el-button
                    >
                    <el-button
                      type="text"
                      disabled
                      @click="handleRemoveListDetail(i)"
                      >删除</el-button
                    >
                  </div>
                </li>
              </ul>
            </el-form-item>
            <el-form-item label="图文详情：">
              <hm-rich-editor
                v-model="ruleForm.spuDetails"
                :html="ruleForm.spuDetails"
              />
            </el-form-item>
            <div id="specification">2.规格/库存信息</div>
            <el-form-item
              label="规格信息"
              class="is-required"
              prop="skuModelList"
              v-if="ruleForm.skuModelList.length"
            >
              <div class="table" v-show="ruleForm.skuModelList.length">
                <div class="table-control flex flex-end">
                  <el-input
                    disabled
                    class="mr10"
                    v-model="wxshopPrice"
                    @input="filterGt0OrFixed2ByData('wxshopPrice')"
                    size="small"
                    style="100px"
                    placeholder="输入零售价"
                  ></el-input>
                  <div class="pointer">
                    <span class="delete-icon hmicon icon-xitong"></span>
                    批量设置
                  </div>
                </div>
                <div class="table-body">
                  <div class="table-row flex">
                    <div
                      class="flex-1 text-center"
                      v-for="(v, i) in ruleForm.skuModelListCopy"
                      :key="i"
                    >
                      {{ v.specName }}
                    </div>
                    <div class="flex-1 text-center">网店售价</div>
                    <div class="flex-1 text-center">可售库存</div>
                    <div class="flex-1 text-center">操作</div>
                  </div>
                  <div
                    class="table-row flex"
                    v-for="(v, i) in ruleForm.skuModelList"
                    :key="i"
                    :class="{ highlight: v.skuId === skuId }"
                  >
                    <div
                      class="flex-1 text-center"
                      v-for="(item, index) in v.specValueList"
                      :key="index"
                    >
                      {{ item.specValue }}
                    </div>
                    <div class="flex-1 flex flex-center">
                      <!-- <el-input  size="small" v-model="v.wxshopPrice"></el-input> -->
                      <div
                        class="el-input el-input el-input--small"
                        style="width: 100px"
                      >
                        <input
                          disabled
                          class="el-input__inner"
                          size="small"
                          v-model="v.wxshopPrice"
                        />
                      </div>
                    </div>
                    <div class="flex-1 flex flex-center">
                      <div
                        class="el-input el-input el-input--small"
                        style="width: 100px"
                      >
                        <input
                          disabled
                          class="el-input__inner"
                          size="small"
                          v-model="v.stockNum"
                        />
                        <!-- <el-input  size="small" v-model="v.markingPrice"></el-input> -->
                      </div>
                    </div>
                    <div class="flex-1 flex flex-center">
                      <el-checkbox
                        disabled
                        @change="setBindState(v)"
                        class="mr10"
                        v-model="v.bindState"
                        >关联</el-checkbox
                      >
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item
              label="可售库存"
              prop="stockNum"
              v-if="!ruleForm.skuModelList.length"
            >
              <el-input
                disabled
                size="small"
                class="mr10 ipt"
                clearable
                v-model.trim="ruleForm.stockNum"
                placeholder="请选择可售库存"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="网店售价"
              prop="wxshopPrice"
              v-if="!ruleForm.skuModelList.length"
            >
              <el-input
                disabled
                size="small"
                class="mr10 ipt"
                clearable
                @input="filterGt0OrFixed2('wxshopPrice')"
                v-model.trim="ruleForm.wxshopPrice"
                placeholder="请输入商品售价"
              ></el-input>
              <el-input
                disabled
                size="small"
                class="mr10 ipt"
                clearable
                @input="filterGt0OrFixed2('markingPrice')"
                v-model.trim="ruleForm.markingPrice"
                placeholder="请输入划线价"
              ></el-input>
            </el-form-item>
            <div id="way">3.销售限制</div>
            <el-form-item label="每人限购：">
              <el-input
                disabled
                size="small"
                class="mr10 ipt"
                clearable
                @input="filterGt0('eachMemberPurchaseLimit')"
                v-model.trim="ruleForm.eachMemberPurchaseLimit"
                placeholder="请输入商品限购数额"
              ></el-input>
              <div class="form-item-tip">
                默认-1表示不限购，若为一品多码商品时，限购为1表示多规格商品只能购买其中一个
              </div>
            </el-form-item>
            <!-- <el-form-item label="购买权限：">
              <el-select
                clearable
                disabled
                v-model="ruleForm.memberPurchaseGroupList"
                placeholder="请选择用户类型"
                size="small"
                filterable
                multiple
              >
                <el-option
                  :label="v.groupAppellation"
                  :value="v.groupId"
                  v-for="(v, i) in memberLimitList"
                  :key="i"
                ></el-option>
              </el-select>
              <div class="form-item-tip">
                默认不限制，所有会员都可以购买；若限制会对客户身份进行限制，如PLUS会员专供
              </div>
            </el-form-item> -->
            <el-form-item label="开售时间：">
              <el-date-picker
                disabled
                v-model="ruleForm.salesStartTime"
                type="datetime"
                align="right"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择开售时间"
                size="small"
                class="mr10"
              ></el-date-picker>
              <div class="form-item-tip">
                开售商品必须先上架，需商品在指定时间下，才能开售，否则上架状态下，显示开售倒计时
              </div>
            </el-form-item>
            <el-form-item label="要求留言：">
              <div class="flex item-center pointer">
                <div class="add-wrapper mr10">
                  <span class="hmicon icon-hao pointer"></span>
                </div>
                添加字段
              </div>
              <ul>
                <li
                  class="flex item-center"
                  v-for="(v, i) in ruleForm.messageModelList"
                  :key="i"
                >
                  <!-- <el-input v-model="v.comments" class="mr10" size="small" placeholder="留言"></el-input> -->
                  <el-select
                    disabled
                    v-model="v.messageId"
                    class="mr10"
                    size="small"
                    placeholder="请选择文本类型"
                  >
                    <el-option
                      :label="v.messageName"
                      :value="v.messageId"
                      v-for="(v, i) in wxShopSpuPostMessageList"
                      :key="i"
                    ></el-option>
                  </el-select>
                  <el-checkbox disabled class="mr10" v-model="v.isMustWrite"
                    >必填</el-checkbox
                  >
                  <div class="minus-wrapper">
                    <span class="hmicon icon-jianhao pointer"></span>
                  </div>
                </li>
              </ul>
            </el-form-item>
            <el-form-item label="上架时间：">
              <el-date-picker
                disabled
                v-model="ruleForm.upStartTime"
                type="datetime"
                placeholder="请选择上架时间"
                align="right"
                value-format="yyyy-MM-dd HH:mm:ss"
                size="small"
                class="mr10"
              ></el-date-picker>
              <div class="form-item-tip">上架后商品才可销售</div>
            </el-form-item>
            <el-form-item label="下架时间：">
              <el-date-picker
                disabled
                v-model="ruleForm.downStartTime"
                type="datetime"
                placeholder="请选择下架时间"
                align="right"
                value-format="yyyy-MM-dd HH:mm:ss"
                size="small"
                class="mr10"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="可售门店：">
              <el-select
                disabled
                clearable
                v-model="ruleForm.shopModelList"
                placeholder="请选择门店"
                size="small"
                filterable
                @change="getCheckedStore"
                multiple
                ><el-option
                  label="全部门店"
                  :disabled="selectOther"
                  value="all"
                ></el-option>
                <el-option
                  :label="v.shopName"
                  :disabled="selectAll"
                  :value="v.shopId"
                  v-for="(v, i) in microShopStoreList"
                  :key="i"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="配送方式：">
              <el-select
                disabled
                clearable
                v-model="ruleForm.deliveryModelList"
                placeholder="请选择配送方式"
                size="small"
                filterable
                multiple
              >
                <el-option
                  :label="v.itemText"
                  :value="v.itemValue"
                  v-for="(v, i) in deliveryMethodsList"
                  :key="i"
                ></el-option>
              </el-select>
            </el-form-item>
            <div class="flex flex-center">
              <!-- <el-button
                type="primary"
                size="small"
                @click="submitForm('ruleForm')"
                >提交</el-button
              > -->
              <el-button size="small" @click="$router.back(-1)">返回</el-button>
            </div>
          </el-form>
        </div>
      </el-scrollbar>
    </div>
    <hm-filter-goods
      @setGoodsInfo="setGoodsInfo"
      :visible="dialogVisible"
      @close="dialogVisible = false"
    ></hm-filter-goods>
  </el-card>
</template>

<script>
import myUpload from "vue-image-crop-upload";
import HmRichEditor from "@/components/HmRichEditor";
import HmFilterGoods from "@/components/HmFilterGoods";
import HmStep from "@/components/HmStep";
import { mapGetters } from "vuex";
export default {
  components: { myUpload, HmRichEditor, HmStep, HmFilterGoods },
  data() {
    const patternCategoryFunc = function(rule, val, callback) {
      if (
        this.ruleForm.wxshopCategoryId &&
        !this.ruleForm.wxshopCategoryId.length
      ) {
        this.isShowCategoryErr = true;
        return callback(new Error("请选择商品分类"));
      }
      this.isShowCategoryErr = false;
      callback();
    }.bind(this);
    const patternFunc = function(rule, val, callback) {
      this.ruleForm.skuModelList.map(v => {
        // eslint-disable-next-line no-unused-vars
        for (let key in v) {
          if (!v.wxshopPrice || !v.stockNum) {
            return callback(new Error("请选择规格"));
          }
        }
        callback();
      });
      callback();
    }.bind(this);
    const patternAttributeFunc = function(rule, val, callback) {
      if (!this.ruleForm.spuAttributeList.length) {
        this.isShowAttributeErr = true;
        return callback(new Error("请选择分类"));
      }
      this.isShowAttributeErr = false;
      callback();
    }.bind(this);
    const patternDelay = function(rule, val, callback) {
      if (this.ruleForm.overstockSales === "open") {
        if (!this.ruleForm.afterPayDays && !this.ruleForm.deliveryDeadline) {
          return callback(new Error("请选择预购发货时间"));
        }
        callback();
      }
      callback();
    }.bind(this);
    // typeId 父级Id
    // specId 子级Id
    return {
      url: "",
      dialogVisible: false,
      selectOther: false,
      selectAll: false,
      specification: "",
      currentStep: 1,
      allAttr: [],
      deliveryMethodsList: [],
      wxShopSpuPostMessageList: [],
      memberLimitList: [],
      showGoodsSn: true,
      steps: [
        {
          name: "添加基本信息",
          id: "base"
        },
        {
          name: "价格/库存信息",
          id: "specification"
        },
        {
          name: "销售限制",
          id: "way"
        }
      ],
      isShowCategoryErr: true,
      isShowAttributeErr: true,
      scrollHeight: 0,
      showDetail: false,
      show: false,
      isMininum: true,
      applyCount: 0,
      activityDate: "",
      inputValue: "",
      activeTab: 0,
      type: 0,
      spuSlideShowPicList: [],
      storeId: "",
      startDate: "",
      validDate: "",
      editorOption: {},
      selectedIndex: "",
      chargeType: "",
      categoryFunc: {
        checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryMicroShopGoodsCategoryTree", {
                categoryLevel: 1
              })
              .then(res => {
                res.result.forEach(v => {
                  v.value = v.wxshopCategoryId;
                  v.label = v.categoryName;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryMicroShopGoodsCategoryTree", {
                categoryLevel: level + 1,
                wxshopParentCategoryId: data.wxshopCategoryId
              })
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.wxshopCategoryId;
                    v.label = v.categoryName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      wxshopPrice: "",
      skuId: "",
      ruleForm: {
        stockNum: "",
        wxshopPrice: "",
        wxshopCategoryId: [],

        spuType: "reality",
        spuSlideShowPicList: [],
        memberLaunchRefund: "",
        overstockSales: "open",
        overstockSalesMode: "date",
        deliveryDeadline: "",
        markingPrice: "",
        afterPayDays: "",
        sellingPoint: "",
        goodsSn: "",
        spuId: "",
        salesStartTime: "",
        eachMemberPurchaseLimit: -1,
        messageModelList: [],
        upStartTime: "",
        downStartTime: "",
        deliveryModelList: [],
        shopModelList: [],
        wxshopSpuName: "",
        skuModelList: [],
        brandId: "",
        spuAttributeList: [],
        basePrice: "",
        spuMainPic: "",
        spuDetails: "",
        skuModelListCopy: [],
        specificationList: [
          {
            specName: "",
            specId: "",
            specModels: []
          }
        ]
      },
      rules: {
        goodsSn: {
          required: true,
          message: "请输入商品货号",
          trigger: "change"
        },
        stockNum: {
          required: true,
          message: "请输入商品库存",
          trigger: "blur"
        },
        overstockSalesMode: {
          validator: patternDelay,
          trigger: "blur"
        },
        wxshopSpuName: {
          required: true,
          message: "请输入商品名称",
          trigger: "blur"
        },
        category: {
          validator: patternCategoryFunc,
          trigger: "change"
        },
        brandId: {
          required: true,
          message: "请选择商品品牌",
          trigger: "change"
        },
        attribute: {
          validator: patternAttributeFunc,
          trigger: "blur"
        },
        wxshopPrice: {
          required: true,
          message: "请输入建议零售价",
          trigger: "blur"
        },
        skuModelList: [
          {
            validator: patternFunc,
            trigger: "blur"
          }
        ],
        actMemberUpperLimit: [
          { required: true, message: "请输入活动人数上限", trigger: "blur" },
          {
            validator(rule, value, callback) {
              if (Number.isInteger(Number(value)) && Number(value) >= 0) {
                callback();
              } else {
                callback(new Error("请输入大于等于0的正整数"));
              }
            },
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: mapGetters([
    "specList",
    "allBrandList",
    "attrList",
    "microShopStoreList",
    "microShopGoodsDetails"
  ]),
  watch: {
    microShopGoodsDetails(val) {
      if (val) {
        for (let key in val) {
          if (this.ruleForm.hasOwnProperty(key)) {
            this.ruleForm[key] = val[key];
          }
        }
        setTimeout(() => {
          if (
            this.ruleForm.messageModelList &&
            this.ruleForm.messageModelList.length
          ) {
            this.ruleForm.messageModelList.forEach(v => {
              v.isMustWrite = v.isMustWrite === "true";
            });
          }
          this.ruleForm.wxshopPrice = val.wxshopPrice;
          this.ruleForm.afterPayDays = val.afterPayDays;
          this.ruleForm.memberLaunchRefund = val.memberLaunchRefund;
          this.$refs.cascader.inputValue = val.categoryName;
        }, 0);
      }
    },
    "ruleForm.overstockSalesMode": {
      handler() {
        this.ruleForm.afterPayDays = "";
        this.ruleForm.deliveryDeadline = "";
      },
      deep: true
    },
    "ruleForm.spuType": {
      handler(val) {
        this.ruleForm.memberLaunchRefund = val === "virtual" ? "no" : "";
      },
      deep: true
    }
  },
  created() {
    this.$store.dispatch("queryMicroStoreList");
    this.$store.dispatch("queryMicroShopGoodsDetails", {
      wxshopSpuId: this.$route.query.wxshopSpuId
    });
    this.skuId = this.$route.query.skuId;
    this.queryDeliveryMethod();
    this.queryWxShopSpuPostMessage();
    this.queryMemberLimit();
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("scroll", this.handleScroll, true);
      window.addEventListener("resize", this.handleResize, true);
      this.calcHeight();
    });
  },
  destroyed: function() {
    window.removeEventListener("scroll", this.handleScroll); //  离开页面清除（移除）滚轮滚动事件
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    getCheckedStore(storeList) {
      this.selectOther = storeList.findIndex(o => o !== "all") > -1;
      this.selectAll = storeList.findIndex(o => o === "all") > -1;
    },
    setGoodsInfo(info) {
      for (let key in info) {
        if (this.ruleForm.hasOwnProperty(key)) {
          this.ruleForm[key] = info[key];
        }
      }
      this.ruleForm.wxshopCategoryId = [];
      info.skuModelList.forEach(v => {
        v.wxshopPrice = v.recommendedRetailPrice;
        v.stockNum = "";
        v.bindState = true;
        delete v.spuId;
        delete v.specIdGroup;
        delete v.specBarcode;
        delete v.recommendedRetailPrice;
      });
      this.ruleForm.wxshopSpuName = info.spuName;

      this.showGoodsSn = false;
    },
    setBindState(v) {
      if (typeof v.bindState === "string") {
        v.bindState = !(v.bindState === "true");
      } else {
        v.bindState = !v.bindState;
      }
      this.$forceUpdate();
    },
    async queryWxShopSpuPostMessage() {
      const { result } = await this.$store.dispatch(
        "queryWxShopSpuPostMessage"
      );
      this.wxShopSpuPostMessageList = result;
    },
    async queryDeliveryMethod() {
      const { result } = await this.$store.dispatch("queryDeliveryMethod");
      this.deliveryMethodsList = result;
    },
    async queryMemberLimit() {
      const { result } = await this.$store.dispatch("queryMemberLimit", {
        pageSize: 9999999,
        pageNo: 1
      });
      if (result) {
        this.memberLimitList = result.records;
      }
    },
    // addtionTime() {
    //   this.ruleForm.messageModelList.push({
    //     comments: "",
    //     type: "",
    //     isMustWrite: false
    //   });
    // },
    // deleteTime(i) {
    //   this.ruleForm.messageModelList.splice(i, 1);
    // },
    // 过滤大于0
    filterGt0(prop) {
      if (this.ruleForm[prop].length === 1) {
        this.ruleForm[prop] = this.ruleForm[prop].replace(/[^0-9]/g, "");
      } else {
        this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)|\D/g, "");
      }
    },
    handleResize() {
      this.calcHeight();
    },
    calcHeight() {
      setTimeout(() => {
        const headerHeight = document.querySelector(".navbar")
          ? document.querySelector(".navbar").getBoundingClientRect().y
          : 0;
        const tagHeight = document.querySelector(".tags-view-container")
          ? document
              .querySelector(".tags-view-container")
              .getBoundingClientRect().y
          : 0;
        const stepsHeight = document.querySelector(".step-wrapper")
          ? document.querySelector(".step-wrapper").getBoundingClientRect().y
          : 0;
        const footerHeight = document.querySelector(".el-footer")
          ? document.querySelector(".el-footer").getBoundingClientRect().height
          : 0;
        this.scrollHeight =
          window.innerHeight -
          headerHeight -
          tagHeight -
          stepsHeight -
          footerHeight -
          80;
      }, 0);
    },
    handleScroll(e) {
      this.steps.map((v, i) => {
        const ele = document.getElementById(v.id);
        if (ele) {
          const offsetTop = ele.offsetTop;
          if (e.target.scrollTop + 360 > offsetTop) {
            this.currentStep = i + 1;
          } else if (e.target.scrollTop < 100) {
            this.currentStep = 1;
          } else {
            this.currentStep = i - 1;
          }
        }
      });
    },
    windowScroll(i) {
      this.$nextTick(() => {
        document.getElementById(this.steps[i].id).scrollIntoView();
        this.currentStep = i + 1;
      });
    },
    addSpecification() {
      this.ruleForm.specificationList.push({
        specName: "",
        specId: "",
        specModels: []
      });
    },
    deleteSpecification(v, i) {
      this.ruleForm.skuModelList.forEach(o => {
        o.specValueList.forEach((p, index) => {
          v.attr.map(q => {
            if (p.specId === q.specId) {
              o.specValueList.splice(index, 1);
            }
          });
        });
      });
      this.ruleForm.specificationList.splice(i, 1);
    },
    // batchSetting() {
    //   this.ruleForm.skuModelList.forEach(v => {
    //     v.wxshopPrice = this.wxshopPrice;
    //   });
    // },
    setAttrList(v, index) {
      let len = this.ruleForm.specificationList.length;
      this.ruleForm.skuModelList = [];
      let resultLen = 1;
      this.ruleForm.specificationList.map(o => {
        resultLen = resultLen * o.attr.length;
      });
      if (len === 1) {
        for (let i = 0; i < resultLen; i++) {
          let specValueList = [];
          specValueList[index] = v.attr[i];
          this.ruleForm.skuModelList.push({
            specValueList,
            specBarcode: "",
            wxshopPrice: ""
          });
        }
      } else if (len === 2) {
        let arr = [];
        this.ruleForm.specificationList[0].attr.map(o => {
          this.ruleForm.specificationList[1].attr.map(p => {
            let arr2 = [];
            arr2.push(o, p);
            arr.push(arr2);
          });
        });
        for (let i = 0; i < resultLen; i++) {
          this.ruleForm.skuModelList.push({
            specValueList: arr[i],
            specBarcode: "",
            wxshopPrice: ""
          });
        }
      } else if (len === 3) {
        let arr = [];
        this.ruleForm.specificationList[0].attr.map(o => {
          this.ruleForm.specificationList[1].attr.map(p => {
            this.ruleForm.specificationList[2].attr.map(q => {
              let arr2 = [];
              arr2.push(o, p, q);
              arr.push(arr2);
            });
          });
        });
        for (let i = 0; i < resultLen; i++) {
          this.ruleForm.skuModelList.push({
            specValueList: arr[i],
            specBarcode: "",
            wxshopPrice: ""
          });
        }
      }
    },
    switchSpecification(v, i) {
      const currentRow = this.specList.find(o => o.specId === v.specId);
      this.selectedIndex = i;
      v.attr = [];
      if (currentRow) {
        v.specModels = currentRow.specModels;
        v.specName = currentRow.specName;
      }
    },
    toUrl(url) {
      let routeUrl = this.$router.resolve({
        name: url
      });
      window.open(routeUrl.href, "_blank");
    },
    filterGt0OrFixed2ByData(prop) {
      // this[prop] = this[prop].replace(/^(0+)/, ""); //过滤0开头
      this[prop] = this[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this[prop] = this[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this[prop] = this[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this[prop] = this[prop].replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
      if (this[prop].indexOf(".") < 0 && this[prop] != "") {
        //首位是0的话去掉
        this[prop] = parseFloat(this[prop]);
      }
    },
    filterGt0OrFixed2(prop) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    },
    toggleShow() {
      this.show = !this.show;
    },
    toggleShowDetail() {
      this.showDetail = !this.showDetail;
    },
    cropSuccess() {},
    /**
     * upload success
     *
     * [param] jsonData   服务器返回数据，已进行json转码
     * [param] field
     */
    cropUploadSuccess(jsonData) {
      if (this.show) {
        this.ruleForm.spuMainPic = jsonData.result;
        this.spuSlideShowPicList.push(jsonData.result);
      } else if (this.showDetail) {
        this.ruleForm.spuSlideShowPicList.push(jsonData.result);
      }
    },
    cropUploadFail() {},
    // submitForm(formName) {
    //   this.$refs[formName].validate(valid => {
    //     if (valid) {
    //       let params = JSON.parse(JSON.stringify(this.ruleForm));
    //       if (typeof params.wxshopCategoryId !== "string") {
    //         params.wxshopCategoryId = params.wxshopCategoryId.length
    //           ? params.wxshopCategoryId[params.wxshopCategoryId.length - 1]
    //           : "";
    //       }
    //       delete params.specificationList;
    //       params = Object.assign(params, {
    //         spuSlideShowPicList: this.ruleForm.spuSlideShowPicList,
    //         wxshopSpuId: this.$route.query.wxshopSpuId
    //       });
    //       this.$store.dispatch("editMicroShopGoods", params).then(res => {
    //         if (res.code === "0") {
    //           this.$message({
    //             message: "操作成功",
    //             type: "success"
    //           });
    //           this.$router.back(-1);
    //         }
    //       });
    //     } else {
    //       return false;
    //     }
    //   });
    // },
    // 移除上传文件
    handleRemove() {
      this.ruleForm.spuMainPic = "";
    },
    // 上传成功后的回调
    uploadSuccess(response) {
      this.ruleForm.spuMainPic = response.result;
      this.$message({
        type: "success",
        message: "上传成功！"
      });
    },
    // 上传错误
    uploadError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
    },
    // 上传前对文件的大小的判断
    beforeUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "jpg";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      const limitSize = file.size / 1024 <= 300;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning"
        });
      }
      if (!limitSize) {
        this.$message({
          message: "上传模板大小不能超过 300k!",
          type: "warning"
        });
      }
      const isSize = new Promise((resolve, reject) => {
        let width = 750;
        let height = 750;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function() {
          let valid = img.width == width && img.height == height;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then(
        () => {
          return file;
        },
        () => {
          this.$message({
            message: "请上传750*750的图片!",
            type: "warning"
          });
          return Promise.reject();
        }
      );
      return (
        (extension || extension2 || extension3 || extension4) &&
        limitSize &&
        isSize
      );
    },
    handleRemoveListDetail(file) {
      if (typeof file === "number") {
        this.ruleForm.spuSlideShowPicList.splice(file, 1);
      } else {
        const index = this.ruleForm.spuSlideShowPicList.findIndex(
          v => v === file.response.result
        );
        this.ruleForm.spuSlideShowPicList.splice(index, 1);
      }
    },
    uploadListDetailError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
    },
    uploadListDetailSuccess(response) {
      this.ruleForm.spuSlideShowPicList.push(response.result);
      this.$message({
        type: "success",
        message: "上传成功！"
      });
    },
    setFirst(i) {
      let tmp = this.ruleForm.spuSlideShowPicList[0];
      this.ruleForm.spuSlideShowPicList[0] = this.ruleForm.spuSlideShowPicList[
        i
      ];
      this.ruleForm.spuSlideShowPicList[i] = tmp;
      this.$forceUpdate();
    }
  }
};
</script>
<style lang="scss">
.details-distribution-container {
  .el-form-item__content {
    margin-left: 240px !important;
  }
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .step-wrapper {
    border-bottom: 1px solid #ddd;
  }
  .btn {
    margin-left: 10px;
    .hmicon {
      font-size: 12px;
      margin-right: 5px;
    }
  }
}
</style>
<style lang="scss" scoped>
.title {
  color: #606266;
  font-weight: bold;
  font-size: 14px;
}

.table {
  margin-top: 20px;
  border: 1px solid #dcdfe6;
  border-radius: 5px;
  .table-control {
    padding: 0 29px;
    border-bottom: 1px solid #ddd;
  }
  .table-row:nth-child(odd) {
    background: #f7f7f7;
    color: #222;
  }
}

.specification-list {
  li {
    padding: 7px 10px;
    margin: 0;
    color: #666;
    background-color: #f8f8f8;
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    margin: 20px 0;
  }
}

.priview {
  position: relative;
  width: 250px;
  height: 206px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}

.add-wrapper {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #e50065;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  margin-left: 10px;
  user-select: none;
  .hmicon {
    font-size: 14px;
  }
}

.highlight {
  background-color: #e50065 !important;
}

.minus-wrapper {
  width: 20px;
  height: 20px;
  line-height: 20px;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  border: 1px solid #e50065;
  margin-left: 10px;
  box-sizing: border-box;
  user-select: none;
  .hmicon {
    color: #e50065;
    font-size: 14px;
  }
}
</style>
